export const APP_STORE_URL =
  'https://apps.apple.com/br/app/qualidoc/id1517845569';

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=cx.driven.qualidoc&hl=pt_BR';

export type MobileStore = 'ios' | 'android' | 'other';

export function getMobileStore(userAgent: string): MobileStore {
  const isIos =
    /iPad|iPhone|iPod/.test(userAgent) && !/MSStream/.test(userAgent);
  if (isIos) {
    return 'ios';
  }
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  return 'other';
}

export function getPreferredStoreUrl(userAgent: string): string {
  return getMobileStore(userAgent) === 'ios' ? APP_STORE_URL : PLAY_STORE_URL;
}
